import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ForYouIfSection() {
  const points = ['Sentís que todo está carísimo', 'Te cansaste de productos que no funcionan', 'Querés soluciones naturales y reales', 'Extrañás cuando con poco alcanzaba'];
  return <section className="py-16 bg-[#F9F4EF] border-y border-[#D4A5A5]/20" data-id="element-76">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#5C4033] mb-10" data-id="element-79">
            Esto es para vos si...
          </h2>

          <div className="grid sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-80">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 text-left bg-white p-5 rounded-xl shadow-sm border border-[#D4A5A5]/10" data-id="element-81">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#9CAF88] flex items-center justify-center mt-0.5" data-id="element-82">
                  <Check className="w-4 h-4 text-white stroke-[3]" data-id="element-83" />
                </div>
                <p className="text-lg text-[#5C4033] font-medium leading-relaxed" data-id="element-84">
                  {point}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}